import { render, staticRenderFns } from "./appTemplate.vue?vue&type=template&id=fdd0646a&scoped=true&"
import script from "./appTemplate.vue?vue&type=script&lang=js&"
export * from "./appTemplate.vue?vue&type=script&lang=js&"
import style0 from "./appTemplate.vue?vue&type=style&index=0&id=fdd0646a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd0646a",
  null
  
)

export default component.exports